import { put, takeLatest, all, call } from 'redux-saga/effects';

import { heliumReceive } from 'utils/helpers';

import { integrationActions } from '../slices/integrationSlice';

function* fetchIntegrationStatusSaga(
  action: ReturnType<typeof integrationActions.fetchIntegrationStatus>,
): Generator {
  const { orgId } = action.payload;

  try {
    const integrationData = yield call(heliumReceive, 'getIntegrationMsiAlta', [
      orgId,
    ]);

    if (!integrationData.data || integrationData.data.length === 0) {
      yield put(
        integrationActions.setIntegrationStatus({
          isMsiIntegrated: false,
          isGuestPassIntegrated: false,
          isTokenValid: false,
        }),
      );
      return;
    }

    const initialData = integrationData.data[0];
    const { msiAltaOrgId, guestPassEnabled } = initialData;

    const hasOrgId = !!msiAltaOrgId;
    const guestPassEnabledCondition = guestPassEnabled === 1;

    yield put(
      integrationActions.setIntegrationStatus({
        isMsiIntegrated: hasOrgId,
        isGuestPassIntegrated: hasOrgId && guestPassEnabledCondition,
        isTokenValid: hasOrgId,
      }),
    );
  } catch {
    yield put(
      integrationActions.setError('Failed to fetch integration status'),
    );
  } finally {
    yield put(integrationActions.setLoading(false));
  }
}

export default function* integrationSaga(): Generator {
  yield all([
    takeLatest(
      integrationActions.fetchIntegrationStatus.type,
      fetchIntegrationStatusSaga,
    ),
  ]);
}
